import {BifrostBackendNestApi} from "../gateways/BifrostBackendApi";
import appConfig from "../appconfig";
import {store} from "../store";

const VoucherRedemptionsProvider = {
	async findMany({voucherIds}) {
		const res = await BifrostBackendNestApi.post("/voucher-redemptions", {
			appendAppUserIdInFilter: true,
			filterBy: {
				voucherIds
			}
		},
		{
			params: {
				tenantId: appConfig.tenantId
			},
			headers: {
				Authorizationidp: store.getters.applicationUserIdpToken
			}
		}
		);

		return res.data;
	}
};

export default Object.freeze(VoucherRedemptionsProvider);
